export enum LegalForm {
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
  COLLECTIVE_PROPRIETORSHIP = "COLLECTIVE_PROPRIETORSHIP",
  LIMITED_COMPANY = "LIMITED_COMPANY",
  LIMITED_LIABILITY_COMPANY = "LIMITED_LIABILITY_COMPANY",
  COLLECTIVE = "COLLECTIVE",
  ASSOCIATION = "ASSOCIATION",
  FOUNDATION = "FOUNDATION",
  SPECIAL_LEGAL_FORM = "SPECIAL_LEGAL_FORM",
  SWISS_BRANCH = "SWISS_BRANCH",
  LIMITED_PARTNERSHIP = "LIMITED_PARTNERSHIP",
  ASSOCIATION_LIMITED_BY_SHARES = "ASSOCIATION_LIMITED_BY_SHARES",
  INDIVISION = "INDIVISION",
  PUBLIC_LAW_INSTITUTION = "PUBLIC_LAW_INSTITUTION",
  NON_COMMERCIAL_POWER_OF_ATTORNEY = "NON_COMMERCIAL_POWER_OF_ATTORNEY",
  FOREIGN_BRANCH = "FOREIGN_BRANCH",
}

export enum SignatureType {
  Single = "SINGLE",
  Double = "DOUBLE",
}

export const CybwellSingleSignatureValues = ["2000", "7000"];
export const CybwellDoubleSignatureValues = ["3000", "8000"];

export interface SignatoryType {
  id: string;
  firstName: string;
  lastName?: string;
  signatureType?: SignatureType;
  disabled?: boolean;
}

export type CybwellResponse<T> = {
  RESULT: {
    TRX: {
      STATUS: string;
      ERRORMSG?: string;
      ERRORCOUNT: string;
      ENGINE: string;
      SOURCE?: string;
      COUNT: string;
      DURATION: string;
    };
  } & T;
};

export type CybwellCompany = {
  ehraid: string;
  CHID: string;
  UID: string;
  name: string;
  status: string;
  street: string;
  hnr: string;
  town: string;
  zip: string;
};

export type CompaniesResponse = CybwellResponse<{
  COMPANIES: {
    COMPANY: CybwellCompany | CybwellCompany[];
  };
}>;

export type CybwellCompanyDetail = {
  ehraid: string;
  chid: string;
  uid: string;
  name: string;
  status: string;
  capitalNom: string;
  capitalCur: string;
  legalformid: string;
  legalFormNameDE: string;
  legalFormNameFR: string;
  legalFormNameIT: string;
  legalFormNameEN: string;
  DateOfEntry: string;
  FirstDateOfTheActs: string;
  purpose: string;
  registryOfCommerceId: string;
  phone: string;
  url: string;
  LATESTSHAB: {
    SHAB: {
      shabDate: string;
      shabId: string;
    }[];
  };
  ADDRESSINFORMATION: {
    ADDRESS: {
      Receipt: {
        street: string;
        houseNumber: string;
        town: string;
        swissZipCode: string;
        country: string;
        careOf?: string;
      };
    };
  };
  NOGA: {
    INDUSTRY_CODE: {
      INDUSTRY_CODE: string | string[];
      DescriptionDE: string;
      DescriptionFR: string;
      DescriptionIT: string;
      DescriptionEN: string;
    };
  };
  PEOPLE: {
    PERSON: {
      PersonText: string;
      Titel: string;
      Sex: string;
      Vorname: string;
      Name: string;
      Heimatort: string;
      Wohnort_PLZ: string;
      Wohnort: string;
      Funktion: string;
      Zeichnungsart: string;
      ZeichnungsartID: string;
      ZeichnungsartName: string;
    }[];
  };
};

export type CompanyDetailResponse = CybwellResponse<{
  COMPANYDETAIL: CybwellCompanyDetail;
}>;

export type CybwellBank = {
  Gruppe: string;
  BCNr: string;
  FilialID: string;
  BCNrNeu: string;
  SICNr: string;
  Hauptsitz: string;
  BCArt: string;
  GueltigAb: string;
  SIC: string;
  euroSIC: string;
  Sprache: string;
  Kurzbez: string;
  BankInstitut: string;
  Domizil: string;
  Postadresse: string;
  PLZ: string;
  Ort: string;
  Telefon: string;
  Fax: string;
  Vorwahl: string;
  Landcode: string;
  Postkonto: string;
  SWIFT: string;
};

export type BankResponse = CybwellResponse<{
  BANKS: {
    BANK: CybwellBank | CybwellBank[];
  };
}>;

export type CybwellAdress = {
  LEGACYID: string;
  TYPE: string;
  LABEL: string;
  LAT: string;
  LON: string;
  X: string;
  Y: string;
};

export type AdressesResponse = CybwellResponse<{
  ADRESSES: {
    ADRESS: CybwellAdress | CybwellAdress[];
  };
}>;

export type CybwellAdressDetail = {
  VERSION: string;
  LEGACYID: string;
  TYPE: string;
  LAT: string;
  LON: string;
  X: string;
  Y: string;
  EGID: string;
  STR: string;
  STR1: string;
  HNR: string;
  ZIP: string;
  CITY: string;
  GDENAME: string;
  GDENR: string;
  KT: string;
  BAUZONECODE: string;
  BAUZONELBLDE: string;
  BAUZONELBLFR: string;
  CADASTREFLAECHE: string;
};

export type AdressDetailResponse = CybwellResponse<{
  ADRESSES: {
    ADRESSDETAIL: CybwellAdressDetail;
  };
}>;
